
import { SupplierSizePack } from '@/models/SupplierSizePack';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component<SupplierSizePackAutocomplete>({})
export default class SupplierSizePackAutocomplete extends Vue {

  // #region @VModel
  // #endregion

  // #region @PropSyncs
  // #endregion

  // #region @Props

  @Prop({ default: 'Supplier size pack(s)' })
  protected label!: string;

  @Prop({ default: () => new SupplierSizePack().include('sizes') })
  protected model!: SupplierSizePack;

  @Prop({ default: 'Supplier size pack(s)' })
  protected placeholder!: string;

  // #endregion

  // #region @Refs
  // #endregion

  // #region Props
  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters
  // #endregion

  // #region @Watchers
  // #endregion
}
